import React, { useState, useRef, useEffect } from 'react';
import GrabadorVerificacion from '../components/GrabadorVerificacion';
import { useNavigate } from 'react-router-dom';
import './Proceso_verificacion.css';

const ProcesoVerificacion = () => {
  const navigate = useNavigate();
  
  // URLs desde .env
  const fotoReferenciaA = process.env.REACT_APP_FOTO_REFERENCIA_PASO_A;
  const videoReferenciaA = process.env.REACT_APP_VIDEO_REFERENCIA_PASO_A;
  const fotoReferenciaB = process.env.REACT_APP_FOTO_REFERENCIA_PASO_B;
  const apiVerificacion = process.env.REACT_APP_PROCESO_VERIFICACION_URL;
  
  // Estado para N° de ticket
  const [ticketSeleccionado, setTicketSeleccionado] = useState('');
  const [listaTickets, setListaTickets] = useState([]);
  const [datosCampos, setDatosCampos] = useState({
  nombre: '', edad: '', codigo_verificacion: '', fecha_creacion: ''
});

// Cargar lista de tickets al montar el componente
useEffect(() => {
  fetch(`${apiVerificacion}/get_tickets_by_perfil.php`, {
    method: 'GET',
    credentials: 'include'
  })
    .then(r => r.json())
    .then(data => {
      if (data.success) setListaTickets(data.tickets);
    })
    .catch(err => console.error('Error cargando tickets:', err));
}, [apiVerificacion]);

const buscarTicket = () => {
  if (!ticketSeleccionado) return;
  fetch(`${apiVerificacion}/get_ticket.php?ticket=${ticketSeleccionado}`, {
    method: 'GET',
    credentials: 'include'
  })
    .then(r => r.json())
    .then(data => {
      if (data.success) {
        setDatosCampos({
          nombre: data.nombre,
          edad: data.edad,
          codigo_verificacion: data.codigo_verificacion,
          fecha_creacion: data.fecha_creacion
        });
      }
    })
    .catch(err => console.error('Error buscando ticket:', err));
};

  // Estados para archivos del usuario
  const [videoUsuario, setVideoUsuario] = useState(null);
  const [fotoUsuario, setFotoUsuario] = useState(null);
  const [videoProgress, setVideoProgress] = useState(0);
  const [fotoProgress, setFotoProgress] = useState(0);
  const [videoError, setVideoError] = useState('');
  const [fotoError, setFotoError] = useState('');
  const [aceptaConservacion, setAceptaConservacion] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [envioProgress, setEnvioProgress] = useState(0);
  const [showTicketModal, setShowTicketModal] = useState(false);
  const [segundosVerificando, setSegundosVerificando] = useState(0);

  useEffect(() => {
    if (envioProgress === 100 && enviando) {
      setSegundosVerificando(0);
      const intervaloSegundos = setInterval(() => {
        setSegundosVerificando(prev => prev + 1);
      }, 1000);
      return () => clearInterval(intervaloSegundos);
    }
  }, [envioProgress, enviando]);
  
  // Estados para modales
  const [modalContent, setModalContent] = useState(null);
  const [modalType, setModalType] = useState(''); // 'image' o 'video'
  
  // Referencias
  const videoInputRef = useRef(null);
  const [mostrarGrabador, setMostrarGrabador] = useState(false);
  const fotoInputRef = useRef(null);
  const fotoGaleriaInputRef = useRef(null);
  const modalVideoRef = useRef(null);
  
  const renderGuionTexto = () => (
    <>
      Mi nombre real es [tu nombre real] y mi nombre de publicación es <u>{datosCampos.nombre || '[presiona BUSCAR]'}</u>. Tengo [tu edad real] años. Hoy es <u>{new Date().toLocaleDateString('es-CL', { timeZone: 'America/Santiago', day: 'numeric', month: 'long', year: 'numeric' })}</u> y mi código es <u>{datosCampos.codigo_verificacion || '[presiona BUSCAR]'}</u>. Soy mayor de 18 años y autorizo voluntariamente a Ulalaaa a publicar mis fotos y videos en su sitio web, en las historias de la página y en sus redes sociales de promoción: [indica en cuáles: Telegram, Instagram, TikTok, X, o di ninguna]. Entiendo que puedo pedir el retiro de mi aviso cuando quiera. Autorizo que este video y mi documento se usen solo para verificar mi identidad y mi edad. Nadie me ha presionado para hacer esto. Publicaré mi contenido con el rostro [al descubierto / tapado].
    </>
  );

  // Campos informativos (vendrán del backend)
  const camposInformativos = {
    nombre: '',
    edad: '',
    nombreSitio: 'ULALAAA',
    codigo: '',
    fechaActual: '',
    texto: 'Yo, "NOMBRE_DE_PUBLICACION", soy mayor de 18 años y autorizo a Ulalaaa a publicar mis fotos y videos en su sitio web. Certifico que Ulalaaa. es solo un sitio de publicidad. Luego debes indicar si publicarás el contenido con rostro al descubierto o tapado, debes mencionarlo.'
  };

  // Función para abrir modal de imagen
  const abrirModalImagen = (src) => {
    setModalContent(src);
    setModalType('image');
  };

  // Función para abrir modal de video
  const abrirModalVideo = (src) => {
    setModalContent(src);
    setModalType('video');
  };

  // Función para cerrar modal
  const cerrarModal = () => {
    if (modalVideoRef.current) {
      modalVideoRef.current.pause();
    }
    setModalContent(null);
    setModalType('');
  };

  // Función para controlar video en modal
  const controlarVideo = (accion) => {
    if (modalVideoRef.current) {
      switch(accion) {
        case 'play':
          modalVideoRef.current.play();
          break;
        case 'pause':
          modalVideoRef.current.pause();
          break;
        case 'stop':
          modalVideoRef.current.pause();
          modalVideoRef.current.currentTime = 0;
          break;
        default:
          break;
      }
    }
  };

  // Función para manejar carga de video
  const handleVideoUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setVideoError('');
    
    // Validar que sea video
    if (!file.type.startsWith('video/')) {
      setVideoError('Por favor selecciona un archivo de video válido');
      return;
    }

    // Crear elemento video temporal para obtener duración
    const videoElement = document.createElement('video');
    videoElement.preload = 'metadata';

    videoElement.onloadedmetadata = function() {
      window.URL.revokeObjectURL(videoElement.src);
      const duracion = isFinite(videoElement.duration) ? videoElement.duration : (file.duracionGrabada || videoElement.duration);

      // Validar duración (30-90 segundos)
      if (duracion < 30) {
        setVideoError('MINIMO DEBE DURAR 30 SEGUNDOS, VERIFICA CADA PUNTO A REALIZAR');
        setVideoProgress(0);
        return;
      }

      if (duracion > 90) {
        setVideoError('El video no debe durar más de 90 segundos');
        setVideoProgress(0);
        return;
      }

      // Validar resolucion: el lado mas largo no debe superar 1280px (720p).
      // Videos en FHD/4K son demasiado pesados y fallan al subirse desde datos moviles.
      const ladoLargo = Math.max(videoElement.videoWidth, videoElement.videoHeight);
      if (ladoLargo > 1280) {
        setVideoError('El video esta en una resolucion muy alta (' + videoElement.videoWidth + 'x' + videoElement.videoHeight + '). Antes de grabar, ve a la configuracion de camara de tu celular y baja la calidad a 720p o HD (no uses FHD ni 4K). Si el problema persiste, contacta al area de soporte.');
        setVideoProgress(0);
        return;
      }

      // Simular progreso de carga
      let progress = 0;
      const interval = setInterval(() => {
        progress += 10;
        setVideoProgress(progress);
        
        if (progress >= 100) {
          clearInterval(interval);
          // Crear URL del video para preview
          const videoUrl = URL.createObjectURL(file);
          setVideoUsuario({
            file: file,
            url: videoUrl,
            duracion: duracion
          });
        }
      }, 100);
    };

    videoElement.src = URL.createObjectURL(file);
  };

  // Función para eliminar video
  const eliminarVideo = () => {
    if (videoUsuario && videoUsuario.url) {
      URL.revokeObjectURL(videoUsuario.url);
    }
    setVideoUsuario(null);
    setVideoProgress(0);
    setVideoError('');
    if (videoInputRef.current) {
      videoInputRef.current.value = '';
    }
  };

  // Función para manejar carga de foto
  const handleFotoUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setFotoError('');
    
    // Validar que sea imagen
    if (!file.type.startsWith('image/')) {
      setFotoError('Por favor selecciona un archivo de imagen válido');
      return;
    }

    // Simular progreso de carga
    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      setFotoProgress(progress);
      
      if (progress >= 100) {
        clearInterval(interval);
        // Crear URL de la foto para preview
        const fotoUrl = URL.createObjectURL(file);
        setFotoUsuario({
          file: file,
          url: fotoUrl
        });
      }
    }, 100);
  };

  // Función para eliminar foto
  const eliminarFoto = () => {
    if (fotoUsuario && fotoUsuario.url) {
      URL.revokeObjectURL(fotoUsuario.url);
    }
    setFotoUsuario(null);
    setFotoProgress(0);
    setFotoError('');
    if (fotoInputRef.current) {
      fotoInputRef.current.value = '';
    }
  };

  // Función para enviar solicitud
  const enviarSolicitud = () => {
    // Validar que se haya seleccionado un ticket
    if (!ticketSeleccionado) {
      alert('Por favor selecciona un ticket antes de enviar');
      return;
    }

    // Validar que ambos archivos estén cargados
    if (!videoUsuario) {
      alert('Por favor carga el video del PASO A');
      return;
    }

    if (!fotoUsuario) {
      alert('Por favor carga la foto del PASO B');
      return;
    }

    if (!aceptaConservacion) {
      alert('Debes marcar la casilla de aceptación sobre el uso y conservación de tus documentos');
      return;
    }

    const formData = new FormData();
    formData.append('ticket', ticketSeleccionado);
    formData.append('video_verificacion', videoUsuario.file);
    formData.append('foto_verificacion', fotoUsuario.file);
    formData.append('acepta_aviso', aceptaConservacion ? '1' : '0');

    setEnviando(true);
    setEnvioProgress(0);

    const xhr = new XMLHttpRequest();
    xhr.open('POST', `${apiVerificacion}/put_pro_verificacion.php`, true);
    xhr.withCredentials = true;

    // XMLHttpRequest si permite reportar el progreso de subida, a diferencia de fetch()
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        const porcentaje = Math.round((event.loaded * 100) / event.total);
        setEnvioProgress(porcentaje);
      }
    };

    xhr.onload = () => {
      setEnviando(false);
      let data = null;
      try {
        // El backend puede enviar espacios en blanco antes del JSON
        // (pulsos para mantener la conexion viva durante el escaneo largo)
        const textoLimpio = xhr.responseText.trim();
        const inicioJson = textoLimpio.indexOf('{');
        data = JSON.parse(inicioJson >= 0 ? textoLimpio.substring(inicioJson) : textoLimpio);
      } catch (e) { /* body vacio o invalido, tratamos como exito si status es 2xx */ }

      if (xhr.status >= 200 && xhr.status < 300) {
        if (!data || data.success) {
          setShowTicketModal(true);
          setTimeout(() => {
            setShowTicketModal(false);
            navigate('/estado_verificacion');
          }, 10000);
        } else {
          alert('Error: ' + data.message);
        }
      } else {
        alert((data && data.message) || 'Error al enviar la solicitud. Intenta nuevamente.');
      }
    };

    xhr.onerror = () => {
      setEnviando(false);
      alert('ERROR TECNICO (para soporte): status=' + xhr.status + ' | readyState=' + xhr.readyState + ' | statusText=' + xhr.statusText + '\n\nSe perdio la conexion mientras se procesaba tu solicitud.');
    };

    xhr.send(formData);
  };

  return (
    <div className="proceso-verificacion-container">
      {/* Botón Volver */}
      <button className="btn-volver" onClick={() => navigate(-1)}>
        VOLVER
      </button>

      {/* Título principal */}
      <h1 className="titulo-principal">PROCESO DE VERIFICACION - OBLIGATORIO</h1>
      
      {/* Subtítulo amarillo */}
      <p className="subtitulo-amarillo">
        En algunos pasos que se detallaran a continuación, debemos verificar si eres mayor de edad 
        y tu autenticidad en las fotos y videos de tu publicación
      </p>

      {mostrarGrabador && (
        <GrabadorVerificacion
          guion={<span style={{ color: '#fff', fontWeight: 'bold' }}>{renderGuionTexto()}</span>}
          onCerrar={() => setMostrarGrabador(false)}
          onGrabado={(f) => { setMostrarGrabador(false); handleVideoUpload({ target: { files: [f] } }); }}
        />
      )}
      {/* PASO A */}
      <div className="cuadro-paso">
        <h2 className="titulo-paso">PASO A :</h2>
        
        <p className="texto-informativo">
          Debes realizar ambos pasos, según las indicaciones
        </p>

        <h3 className="subtitulo-video">VIDEO 1 :</h3>

        <p className="texto-instrucciones">
          Debes grabar un video mirando de frente a la cámara, con tu rostro siempre visible y sin cortes, leyendo en voz alta y de forma clara el texto en rojo que aparece más abajo, completando tus datos personales donde está indicado entre corchetes. No necesitas sostener ningún papel. En este video tu rostro debe verse aunque en tu anuncio publiques con el rostro tapado. Lee el código letra por letra y despacio. IDEAL QUE ESTES CON LA MISMA VESTIMENTA QUE LAS FOTOS Y VIDEOS QUE SUBISTE A TU ANUNCIO, esto para poder validar de forma más rápida la revisión.
        </p>
        <p className="texto-instrucciones" style={{ color: '#8B0000', fontWeight: 'bold' }}>
          IMPORTANTE: antes de grabar, revisa la configuracion de camara de tu celular y usa calidad HD (720p), NO FHD ni 4K. Videos en 4K pesan demasiado y pueden fallar al subirse desde
          datos moviles.
        </p>

        {/* Sección de campos informativos y foto referencial */}
        <div className="seccion-campos-referencia">
<div className="columna-campos">
{/* N° de ticket - campo con select */}
  <div className="campo-row">
    <label className="campo-label">N° de ticket</label>
<select
  className="campo-valor"
  value={ticketSeleccionado}
  onChange={(e) => setTicketSeleccionado(e.target.value)}
>
  <option value="">-- Seleccionar --</option>
  {listaTickets.map((t, i) => (
    <option key={i} value={t.ID_TICKET_e_p}>
      {t.ID_TICKET_e_p} - {t.nombre}
    </option>
  ))}
</select>
  </div>

  {/* Botón BUSCAR */}
  <div className="campo-row">
    <label className="campo-label"></label>
    <button className="btn-subir" onClick={buscarTicket}>
      BUSCAR
    </button>
  </div>

{[
{ label: 'Nombre', value: datosCampos.nombre },
{ label: 'Edad', value: datosCampos.edad },
{ label: 'Nombre sitio', value: camposInformativos.nombreSitio, estilo: { fontSize: '16px', fontFamily: 'Arial, sans-serif' } },
{ label: 'Codigo', value: datosCampos.codigo_verificacion },
{ label: 'Fecha (actual)', value: new Date().toLocaleString('es-CL', { timeZone: 'America/Santiago' }) },
  { label: 'Texto', value: (
    <span style={{ color: '#C00000', fontWeight: 'bold' }}>
      {renderGuionTexto()}
    </span>
  ), estilo: { fontSize: '16px', fontFamily: 'Arial, sans-serif' } }
].map((campo, index) => (
  <div key={index} className="campo-row">
    <label className="campo-label">{campo.label}</label>
    <div className="campo-valor" style={campo.estilo || {}}>{campo.value || ''}</div>
  </div>
))}
</div>
        </div>

        <p className="texto-advertencia-rojo">
          DEBES LEER EN VOZ ALTA, EN EL VIDEO, TODO EL TEXTO EN ROJO DE ARRIBA, COMPLETANDO TUS DATOS ENTRE CORCHETES
        </p>

        {/* Nota duración video */}
        <p className="nota-duracion-video">
          VIDEO DEBE DURAR MINIMO 30 SEGUNDOS Y MAXIMO 90 SEGUNDOS
        </p>

        {/* Cuadro para video del usuario */}
        <div className="cuadro-upload-calipso">
          {!videoUsuario ? (
            <div className="upload-placeholder">
              <span className="emoji-video">🎥</span>
            </div>
          ) : (
            <div 
              className="video-preview-container"
              onClick={() => abrirModalVideo(videoUsuario.url)}
            >
              <video>
                <source src={videoUsuario.url} type={/webm/.test(videoUsuario.file.type) ? 'video/webm' : 'video/mp4'} />
              </video>
              <div className="play-overlay">▶</div>
            </div>
          )}
          
          {videoProgress > 0 && videoProgress < 100 && (
            <div className="progress-bar">
              <div className="progress-fill" style={{ width: `${videoProgress}%` }}>
                {videoProgress}%
              </div>
            </div>
          )}
        </div>

        <p className="texto-mantenimiento">
          Mantiene el video en el recuadro, una vez presiones el boton del final del formulario 
          "Envio de solicitud", se cargara en nuestro sistema
        </p>

        {/* Error de video */}
        {videoError && (
          <p className="mensaje-error">{videoError}</p>
        )}

        {/* Botones subir y eliminar video */}
        <div className="botones-container">
          <input 
            type="file" 
            ref={videoInputRef}
            onChange={handleVideoUpload}
            style={{ display: 'none' }}
          />
          <button 
            className="btn-subir"
            onClick={() => {
              if (!datosCampos.codigo_verificacion) {
                setVideoError('Primero selecciona tu N° de ticket y presiona BUSCAR, para que aparezca tu codigo en el texto.');
                return;
              }
              setVideoError('');
              setMostrarGrabador(true);
            }}
          >
            GRABAR VIDEO
          </button>
          <button
            className="btn-subir"
            onClick={() => videoInputRef.current.click()}
          >
            SUBIR DESDE GALERIA
          </button>
          <button 
            className="btn-eliminar"
            onClick={eliminarVideo}
          >
            ELIMINAR
          </button>
        </div>

        {/* Texto informativo largo */}
        <div className="texto-info-largo">
          <p>
            El video que subirás a nuestro sistema, debe cumplir todos los requisitos indicados anteriormente.
          </p>
          <p>
            Tiene que ser un <span className="texto-rojo">"Video claro y real"</span>, debe ser parecida a las 
            fotos y videos que subiste a tu anuncio (rostro, vestimenta).
          </p>
          <p>
            Recuerda que se evaluara este proceso con las imágenes y videos que subiste a tu publicación.
          </p>
          <p>
            En caso de <span className="texto-rojo">"NO ser iguales"</span>, se te notificara de igual forma 
            una vez aprobada.
          </p>
          <p>
            En caso que salga <span className="texto-rojo">"RECHAZADA LA SOLICITUD"</span>, tienes una nueva 
            oportunidad para realizar nuevamente el proceso de verificación, SOLO UNA oportunidad mas, en caso 
            que la segunda sea rechazada, tendrás que nuevamente realizar el proceso desde el inicio, con una 
            nueva publicación y nuevamente el proceso de verificación.
          </p>
        </div>
      </div>

      {/* PASO B */}
      <div className="cuadro-paso">
        <h2 className="titulo-paso">PASO B :</h2>
        
        <div className="texto-info-largo">
          <p>Debemos validar que eres mayor de edad, LO QUE VERIFICAMOS ES LA FECHA DE NACIMIENTO EN AMBOS DOCUMENTOS, COMO LA IMAGEN DE REFERENCIA.</p>
          <p>
            Para ello, es necesario que adjuntes una foto de tu cedula de identidad, con esto validaremos 
            que eres tambien la persona que publico las fotos del anuncio y que apareces en el video
          </p>
          <p>
            Tienes dos opciones con tu pasaporte en caso de ser extranjera o con tu cedula de identidad.
          </p>
          <p>
            Este proceso, solo es con el fin de corroborar la identidad de la persona, verificando la mayoria 
            de edad y si es la persona de las fotos publicadas.
          </p>
          <p>
            Nota: la imagen debe ser clara, ya que no de serlo, sera rechazada la solicitud, este requerimiento 
            es obligatorio y funciona de igual forma que el del PASO A, en caso de ser rechazada ya para la 
            tercera vez, solo tienes una oportunidad en caso que seas rechazada, tendras que realizar el proceso 
            completo nuevamente, osea volver a publicar tu aviso.
          </p>
        </div>

        {/* Contenedor de cuadros foto usuario y foto referencia */}
        <div className="seccion-fotos-paso-b">
          {/* Cuadro para foto del usuario */}
          <div className="columna-foto-usuario">
            <div className="cuadro-upload-calipso">
              {!fotoUsuario ? (
                <div className="upload-placeholder">
                  <span className="emoji-imagen">🖼️</span>
                </div>
              ) : (
                <div 
                  className="foto-preview-container"
                  onClick={() => abrirModalImagen(fotoUsuario.url)}
                >
                  <img src={fotoUsuario.url} alt="Foto Cédula" />
                </div>
              )}
              
              {fotoProgress > 0 && fotoProgress < 100 && (
                <div className="progress-bar">
                  <div className="progress-fill" style={{ width: `${fotoProgress}%` }}>
                    {fotoProgress}%
                  </div>
                </div>
              )}
            </div>

            <p className="texto-mantenimiento-foto">
              Solo mantén la imagen en el recuadro para subirla al sistema, luego al final del formulario "Envío de solicitud"
            </p>

            {/* Error de foto */}
            {fotoError && (
              <p className="mensaje-error">{fotoError}</p>
            )}

            {/* Botones subir y eliminar foto */}
            <div className="botones-container">
              <input 
                type="file" 
                ref={fotoInputRef}
                accept="image/*"
                capture="environment"
                onChange={handleFotoUpload}
                style={{ display: 'none' }}
              />
              <input 
                type="file" 
                ref={fotoGaleriaInputRef}
                accept="image/*"
                onChange={handleFotoUpload}
                style={{ display: 'none' }}
              />
              <button 
                className="btn-subir"
                onClick={() => fotoInputRef.current.click()}
              >
                TOMAR FOTO
              </button>
              <button 
                className="btn-subir"
                onClick={() => fotoGaleriaInputRef.current.click()}
              >
                GALERIA
              </button>
              <button 
                className="btn-eliminar"
                onClick={eliminarFoto}
              >
                ELIMINAR
              </button>
            </div>
          </div>

          {/* Foto de referencia PASO B */}
          <div className="columna-referencia">
            <div 
              className="cuadro-referencia-rojo imagen-clickable"
              onClick={() => abrirModalImagen(fotoReferenciaB)}
            >
              <img 
                src={fotoReferenciaB} 
                alt="Foto Referencial Cedula" 
              />
            </div>
            <p className="texto-referencial">FOTO REFERENCIAL</p>
          </div>
        </div>
      </div>

      {/* Botón final Envía tu solicitud */}
      <div className="boton-final-container">
        {enviando ? (
          <div className="envio-progress-container">
            <p className="envio-progress-texto">
              {envioProgress < 100
                ? `Enviando archivos, no cierres ni minimices esta pantalla... ${envioProgress}%`
                : 'Verificando el archivo, puede tardar varios minutos si el video es de alta resolucion. NO minimices ni cierres esta pantalla, espera el mensaje de confirmacion que aparecera al terminar.'}
            </p>
            <div className="progress-bar-envio">
              <div className="progress-fill-envio" style={{ width: `${envioProgress}%` }}></div>
            </div>
            {envioProgress === 100 && (
              <>
                <div className="spinner-verificando"></div>
                <div style={{ textAlign: 'center', color: '#cccccc', fontSize: '12px', marginTop: '6px' }}>
                  Verificando hace {segundosVerificando}s...
                </div>
              </>
            )}
          </div>
        ) : (
          <>
          <label style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', margin: '15px 0', fontSize: '14px', textAlign: 'left' }}>
            <input
              type="checkbox"
              checked={aceptaConservacion}
              onChange={(e) => setAceptaConservacion(e.target.checked)}
              style={{ marginTop: '3px' }}
            />
            <span>
              Entiendo y acepto que mi documento de identidad y mi video serán usados solo para verificar mi identidad y mi edad, que serán revisados manualmente por el equipo de Ulalaaa, guardados de forma privada y conservados solo por el tiempo necesario según la <a href="/textos-legales#privacidad" target="_blank" rel="noopener noreferrer">Política de Privacidad</a>. Puedo pedir su eliminación al cerrar mi cuenta.
            </span>
          </label>
          <button className="btn-enviar-solicitud" onClick={enviarSolicitud}>
            Envía tu solicitud
          </button>
        </>
        )}
      </div>

      {/* Modal para zoom de imágenes y videos */}
      {modalContent && (
        <div className="modal-overlay" onClick={cerrarModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={cerrarModal}>✕</button>
            
            {modalType === 'image' && (
              <img src={modalContent} alt="Imagen ampliada" />
            )}
            
            {modalType === 'video' && (
              <div className="modal-video-container">
                <video ref={modalVideoRef} controls muted>
                  <source src={modalContent} type="video/mp4" />
                </video>
                <div className="video-controls">
                  <button onClick={() => controlarVideo('play')}>▶ Play</button>
                  <button onClick={() => controlarVideo('pause')}>⏸ Pause</button>
                  <button onClick={() => controlarVideo('stop')}>⏹ Stop</button>
                </div>
              </div>
            )}
          </div>
        </div>
)}

      {/* Modal Ticket Generado */}
      {showTicketModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0,0,0,0.85)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <div style={{
            textAlign: 'center',
            padding: '40px'
          }}>
            <p style={{
              fontFamily: "'Arial Black', Arial, sans-serif",
              fontSize: '30px',
              fontWeight: '900',
              color: '#ffffff',
              marginBottom: '20px'
            }}>
              ¡SOLICITUD DE VERIFICACION ENVIADA!
            </p>
            <p style={{
              fontFamily: "'Arial Black', Arial, sans-serif",
              fontSize: '30px',
              fontWeight: '900',
              color: '#FFD700',
              marginBottom: '20px'
            }}>
              TU N° DE TICKET ES:
            </p>
            <p style={{
              fontFamily: "'Arial Black', Arial, sans-serif",
              fontSize: '60px',
              fontWeight: '900',
              color: '#FFD700',
              marginBottom: '30px',
              letterSpacing: '8px'
            }}>
              {ticketSeleccionado}
            </p>
            <p style={{
              fontFamily: 'Arial, sans-serif',
              fontSize: '18px',
              color: '#cccccc'
            }}>
              Serás redirigido a Estado de Verificación en 10 segundos...
            </p>
          </div>
        </div>
      )}

      {/* Footer */}
      <footer className="home-footer">
        <div className="home-footer-top">
          <div className="home-footer-redes">
            <a href="https://www.instagram.com/ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.tiktok.com/@ulalaaaoficial2" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-tiktok"></i>
            </a>
            <a href="https://www.youtube.com/@ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://wa.me/56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-whatsapp"></i>
            </a>
            <a href="#" className="home-footer-social-link">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{width:'22px',height:'22px'}}>
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.259 5.63 5.905-5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="https://t.me/+56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-telegram"></i>
            </a>
          </div>
          <div className="home-footer-logo">
            <img
              src={`${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`}
              alt="Ulalaaa Logo"
              className="home-footer-logo-img"
            />
          </div>
          <div className="home-footer-legal-links">
            <a href="/textos-legales#terminos" className="home-footer-legal-btn">Información Legal - Términos y Condiciones</a>
            <a href="/textos-legales#privacidad" className="home-footer-legal-btn">Política de Privacidad</a>
          </div>
        </div>
        <div className="home-footer-texto">
          Ulalaaa, es un sitio web exclusivo para mayores de 18 años, tanto para las personas publicadas como las que lo visitan, las personas publicadas son verificadas de forma rigurosa, el cual han dado su consentimiento para ser publicadas, este sitio no es una agencia, es solo un medio publicitario que no interviene con ninguna relación laboral con las personas publicadas.
        </div>
        <div className="home-footer-copyright">
          ©2026 Ulalaaa - Todos los derechos Reservados.
        </div>
      </footer>
    </div>
  );
};

export default ProcesoVerificacion;
